import BaseSvg, { Props } from '../BaseSvg'

const HouseSmall: React.FC<Props> = (props) => (
  <BaseSvg {...props}>
    <path d="M16 16H0v-4h1V2.875L8 1l7 1.875V12h1v4zm-3-6H3v4h4v-3h2v3h4v-4zM8 3.07L3 4.409V8h10V4.409L8 3.07zM9 5v2H7V5h2z" />
  </BaseSvg>
)

export default HouseSmall
